export default {
  common: {
    loading: 'Loading...',
    processing: 'Processing...',
    refresh: 'Refresh',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    submit: 'Submit',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    unassigned: 'Unassigned',
    notSet: 'Not set',
    noDescription: 'No description',
    uncategorized: 'Uncategorized',
  },
  navbar: {
    title: '🏥 Vet Scheduler',
    chatSetup: 'Chat Setup',
    scheduleView: 'Schedule View',
    constraints: 'Constraints',
    profile: 'Profile',
    adminPanel: 'Admin Panel',
    logout: 'Logout',
  },
  login: {
    title: '🏥 Vet Scheduler',
    signIn: 'Sign In',
    createAccount: 'Create Account',
    username: 'Username',
    email: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    dontHaveAccount: "Don't have an account? Sign Up",
    alreadyHaveAccount: 'Already have an account? Sign In',
    loginSuccessful: 'Login successful! Redirecting...',
    registrationSuccessful: 'Registration successful! Please login.',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters long',
    unexpectedError: 'An unexpected error occurred',
    demoAccounts: 'Demo Accounts',
    demoAdmin: 'Admin: admin / admin123',
    demoUser: 'User: user / user123',
  },
  chatConstraints: {
    title: 'Chat Setup',
    description: 'Provide your requirements. Save will populate your database with employees, shifts, days, and constraints. Generate schedules for specific weeks from the Constraints page.',
    baseline: 'Baseline',
    freeform: 'Freeform',
    freeformLabel: 'Describe scheduling requirements or add details',
    saveAndFinalize: 'Save & Finalize',
    saveConstraintsOnly: 'Save Constraints Only',
    clearTables: 'Clear Tables',
    askUpdate: 'Ask / Update',
    initDatabase: 'Init Database',
    clarificationsNeeded: 'Clarifications needed',
    yourAnswer: 'Your answer',
    submitClarificationAnswers: 'Submit Clarification Answers',
    constraintsPreview: 'Constraints (preview)',
    setupFinalized: 'Setup finalized successfully!',
    setupFinalizedMessage: 'Employees, shifts, and constraints saved to database. Use Constraints page to generate schedules for specific weeks.',
    employees: 'Employees',
    shifts: 'Shifts',
    constraints: 'Constraints',
    clearedTables: 'Cleared tables. Summary:',
    history: 'History (last 3 turns)',
    mustBeLoggedIn: 'You must be logged in to access the chat setup. Please log in first.',
    needAdminPrivileges: 'You need admin privileges to access the chat setup.',
  },
  scheduleView: {
    title: 'Weekly Schedule',
    weekStartDate: 'Week Start Date (Monday)',
    noScheduleData: 'No schedule data available. Please generate a schedule first.',
    daysScheduled: 'Days Scheduled',
    shiftsAvailable: 'Shifts Available',
    assignedSlots: 'Assigned Slots',
    coverage: 'Coverage',
    pleaseLogin: 'Please log in to view the schedule.',
    shift: 'Shift',
  },
  constraintsView: {
    title: 'Constraints Management',
    subtitle: 'Manage scheduling constraints and their date ranges',
    name: 'Name',
    category: 'Category',
    description: 'Description',
    weight: 'Weight',
    dateStart: 'Date Start',
    dateEnd: 'Date End',
    actions: 'Actions',
    editDates: 'Edit dates',
    totalConstraints: 'Total Constraints',
    withDateRange: 'With Date Range',
    withoutDates: 'Without Dates',
    dateCoverage: 'Date Coverage',
    noConstraintsFound: 'No constraints found. Please add some constraints first.',
    pleaseLogin: 'Please log in to view constraints.',
    generateScheduleForWeek: 'Generate Schedule for Week',
    generateScheduleDescription: 'Select a week (Monday) to generate a schedule using active constraints for that period',
    generating: 'Generating...',
    generateSchedule: 'Generate Schedule',
    editDateRange: 'Edit Date Range for',
    startDate: 'Start Date',
    endDate: 'End Date',
    saveDates: 'Save Dates',
    pleaseSelectWeek: 'Please select a week start date',
    scheduleGenerated: 'Schedule generated for {weekRange}! Check Schedule page.',
    failedToGenerate: 'Failed to generate schedule',
    failedToLoad: 'Failed to load constraints',
    failedToUpdate: 'Failed to update constraint dates',
    weekStartDate: 'Week Start Date (Monday)',
  },
  errors: {
    loginFailed: 'Login failed',
    registrationFailed: 'Registration failed',
    loadFailed: 'Failed to load data',
    saveFailed: 'Failed to save data',
    deleteFailed: 'Failed to delete',
    updateFailed: 'Failed to update',
    networkError: 'Network error. Please check your connection.',
    unauthorized: 'Unauthorized. Please log in.',
    forbidden: 'Forbidden. You do not have permission.',
    notFound: 'Resource not found',
    serverError: 'Server error. Please try again later.',
  },
  success: {
    saved: 'Saved successfully',
    deleted: 'Deleted successfully',
    updated: 'Updated successfully',
    created: 'Created successfully',
  },
};

